'use strict';

// Constructor
var SearchFacets = function() {

  var $checkboxBlock = $(".facets-widget-checkbox")
  var $block = $(".block-facet--checkbox");
  $($checkboxBlock).on("click", function(e){
    e.stopPropagation();

  });
  $($block).on("click", function(e){
    e.stopPropagation();
    var $this = $(this);
    $this.find($checkboxBlock).toggle("fast");
    $this.toggleClass("chevron-open");
  });

  $(".facet-empty").closest(".block-facet--checkbox").css("display", "none");

  $("input[type=checkbox]").each(function () {
    var val = (this.checked ? "1" : "0");

    if(val > 0){
      $(this).parents($checkboxBlock).show();
    }
  })

};

module.exports = SearchFacets;
